import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import englishFlag from "../../assets/flags/en.png";
import danishFlag from "../../assets/flags/da.png";
import finnishFlag from "../../assets/flags/fi.png";
import "./SettingsPage.scss";
import WidePageLayout from "../../components/layout/WidePageLayout";
import { useAppDispatch, useAppSelector } from "../../redux-store";
import { useState } from "react";
import Button from "../../components/Button";
import WebBookingApiKeySettings from "./WebBookingApiKeySettings";
import useFeature from "../../ducks/features/hooks";
import { selectHasApiAccess } from "../../ducks/auth/selectors";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../../ducks/app/web-booker-settings";
import { selectLanguage } from "../../ducks/app/web-booker-settings/selectors";

const SettingsPage = () => {
  const { t } = useTranslation("settings");
  const language = useAppSelector(selectLanguage);
  const dispatch = useAppDispatch();
  const [showDevOptions, setShowDevOptions] = useState(false);
  const apiFeatureEnabled = useFeature("web-booking-api-access");
  const clientHasApiAccess = useAppSelector(selectHasApiAccess);

  const onLanguageChange = (e: any) => {
    dispatch(setLanguage(e.target.value));
  };

  return (
    <WidePageLayout header={"Settings"}>
      <div className="settings-page">
        <div className="mt-3">
          <label id="language-selector__label" htmlFor="language-selector">
            Language
          </label>
          <div className="language-selector__content">
            <FormControl fullWidth>
              <Select
                value={language}
                id="language-selector__select"
                labelId="language-selector__label"
                onChange={(e) => onLanguageChange(e)}
              >
                <MenuItem key="en" value="en">
                  <div className="langauge-selector__option">
                    <img src={englishFlag} alt="English" />
                    <div>English</div>
                  </div>
                </MenuItem>
                <MenuItem key="da" value="da">
                  <div className="langauge-selector__option">
                    <img src={danishFlag} alt="Danish" />
                    <div>Danish</div>
                  </div>
                </MenuItem>
                <MenuItem key="fi" value="fi">
                  <div className="langauge-selector__option">
                    <img src={finnishFlag} alt="Finnish" />
                    <div>Finnish</div>
                  </div>
                </MenuItem>
              </Select>
            </FormControl>
          </div>
          {apiFeatureEnabled && clientHasApiAccess ? (
            <div className="mt-10">
              {showDevOptions ? (
                <WebBookingApiKeySettings />
              ) : (
                <div>
                  <Button
                    variant="primary"
                    onClick={() => setShowDevOptions(true)}
                  >
                    {t("showDevOptionsTitle")}
                  </Button>
                  <div className="mt-2">{t("showDevOptionsText")}</div>
                </div>
              )}
            </div>
          ) : null}
        </div>
      </div>
    </WidePageLayout>
  );
};

export default SettingsPage;
